import { Component, HostListener, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ToolEnum } from 'src/Models/Common';
import { FilterModel } from 'src/Models/filterModel';
import { TrfaAlertsModel } from 'src/Models/TrfaAlertsModel';
import { TrfaAlertService } from 'src/Services/alert.service';
import * as FileSaver from 'file-saver';
import { SessionStorageService } from 'src/common/session-storage.service';

@Component({
  selector: 'app-trfa-alerts',
  templateUrl: './trfa-alerts.component.html',
  styleUrls: ['./trfa-alerts.component.css']
})
export class TrfaAlertsComponent implements OnInit {

  tokenKey: string = '';
  isloading: boolean = false;
  filteModel = new FilterModel();;
  TrfaAlertsModel: TrfaAlertsModel[];
  TrfaAlertsExportModel: TrfaAlertsModel[];
  totalRecordCount: number = -1;
  isAscending: boolean;
  updateId: number = 0;

  upDownAlertDateCSS: string = '';
  upDownNoteCSS: string = '';
  upDownFundCSS: string = '';
  upDownStatusCSS: string = '';
  upDownCreatedDateCSS: string = '';
  upDownModifiedDateCSS: string = '';
  Id: number = 0;
  IsSendEmail: boolean
  productId: number;
  openMenuIndex: number = -1;

  constructor(private readonly toastr: ToastrService,
    private readonly router: Router,
    private readonly trfaAlertServices: TrfaAlertService,
    private readonly titleService: Title,
    private sessionStorageService: SessionStorageService
  ) {
    this.tokenKey = this.sessionStorageService.getTokenValue();
    this.productId = ToolEnum.trfa;
    this.titleService.setTitle('TRFA Alerts');
  }

  ngOnInit() {
    this.filteModel.pageNumber = '1';
    this.filteModel.pageSize = '10';
    this.filteModel.keywordFilter = '';
    this.filteModel.orderBy = 'UpdateId';
    this.filteModel.updateId = 0;
    this.GetTrfaAlertsFindByPages();
  }

  GetTrfaAlertsFindByPages() {
    this.isloading = true;
    this.TrfaAlertsModel = [];
    if (this.filteModel.keywordFilter == "null") this.filteModel.keywordFilter = " ";
    this.filteModel.IsExport = false;
    this.trfaAlertServices.GetTrfaAlertsFindByPages(this.tokenKey, this.filteModel).subscribe(data => {
      if (data['status'] == 'Success') {
        this.isloading = false;
        this.TrfaAlertsModel = data['trfaAlertList'];
        if (this.TrfaAlertsModel != null) {
          if (this.TrfaAlertsModel.length > 0) {
            this.totalRecordCount = +this.TrfaAlertsModel[0].totalRowCount;
          }
          else {
            this.totalRecordCount = 0;
          }
        }
      }
      else {
        this.showMessage(data['status'], 'Error', 'error');
      }

    },
      error => {
        this.showMessage(error, 'Error', 'error');
      }
    );
  }

  keywordFilters($event) {
    this.filteModel.keywordFilter = $event.target.value;
    this.filteModel.pageNumber = '1';
    if ($event.target.value != "" && $event.target.value != null) {
      this.filteModel.keywordFilter = $event.target.value;
    }
    else { this.filteModel.keywordFilter = ''; }

    this.GetTrfaAlertsFindByPages();
  }

  sort(sortBy: any) {
    this.upDownAlertDateCSS = '';
    this.upDownNoteCSS = '';
    this.upDownFundCSS = '';

    if (!this.isAscending) {
      this.isAscending = true;
      this.filteModel.orderBy = sortBy + ' DESC';

      if (sortBy === "updateDate") {
        this.upDownAlertDateCSS = 'fa fa-arrow-down';
      }
      else if (sortBy === "note") {
        this.upDownNoteCSS = 'fa fa-arrow-down';
      }
      else if (sortBy === "fundName") {
        this.upDownFundCSS = 'fa fa-arrow-down';
      }
    }
    else {
      this.isAscending = false;
      this.filteModel.orderBy = sortBy;

      if (sortBy === "updateDate") {
        this.upDownAlertDateCSS = 'fa fa-arrow-up';
      }
      else if (sortBy === "note") {
        this.upDownNoteCSS = 'fa fa-arrow-up';
      }
      else if (sortBy === "fundName") {
        this.upDownFundCSS = 'fa fa-arrow-up';
      }
    }
    this.filteModel.pageNumber = '1';
    this.GetTrfaAlertsFindByPages();
  }

  pageChanged($event) {
    this.filteModel.pageNumber = parseInt($event.page).toString();
    this.GetTrfaAlertsFindByPages();
  }

  showMessage(msg: string, msgTitle: string, msgType: string) {
    if (msgType == 'success') {
      setTimeout(() => this.toastr.success(msg, msgTitle));
    }
    else if (msgType == 'error') {
      setTimeout(() => this.toastr.error(msg, msgTitle));
    }
  }

  redirectToEditView(updateId: any) {
    this.router.navigate(['/admin/trfa/trfa-Alerts/user/' + updateId]);
  }

  SetCancelMailId(updateId: any) {
    this.Id = updateId;
  }

  CancelMail() {
    this.trfaAlertServices.notsentAlertmail(this.tokenKey, this.Id, this.productId).subscribe(
      data => {
        if (data['status'] == 'Success') {
          this.showMessage('', 'Success', 'success');
          this.GetTrfaAlertsFindByPages();
        }
        else
          this.showMessage(data['status'], 'Error', 'error');
      },
      error => {
        this.showMessage(error, 'Error', 'error');
      }
    );
  }

  toggleMenu(index: number) {
    this.openMenuIndex = this.openMenuIndex === index ? -1 : index; // Toggle the menu
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const target = event.target as HTMLElement;
    if (!target.closest('.kebab-menu')) {
      this.openMenuIndex = null;
    }
  }

  ExportTRFAAlerts() {
    this.isloading = true;
    this.TrfaAlertsExportModel = [];
    if (this.filteModel.keywordFilter == "null") this.filteModel.keywordFilter = " ";
    this.filteModel.IsExport = true;
    this.trfaAlertServices.GetTrfaAlertsFindByPages(this.tokenKey, this.filteModel).subscribe(data => {
      if (data['status'] == 'Success') {
        this.TrfaAlertsExportModel = data['trfaAlertList'];
        if (this.TrfaAlertsExportModel != null) {
          if (this.TrfaAlertsExportModel.length > 0) {
            setTimeout(() => {
              this.DownloadTRFAAlerts();
              this.isloading = false;
            }, 2000);
          }
          else {
            this.isloading = false;
            this.toastr.error("No record found", "Error");
          }
        }
        else {
          this.isloading = false;
          this.toastr.error("No record found", "Error");
        }
      }
      else {
        this.isloading = false;
        this.showMessage(data['status'], 'Error', 'error');
      }
    },
      error => {
        this.isloading = false;
        this.showMessage(error, 'Error', 'error');
      }
    );
  }

  DownloadTRFAAlerts() {
    let tableData = document.getElementById("ExportTable").innerHTML;

    var uri = 'data:application/vnd.ms-excel;base64,'
      , template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--><meta http-equiv="content-type" content="text/plain; charset=UTF-8"/></head><body>{table}</body></html>'
      , base64 = function (s) { return window.btoa(unescape(encodeURIComponent(s))) }
      , format = function (s, c) { return s.replace(/{(\w+)}/g, function (m, p) { return c[p]; }) }
    let html = "<table><tr class='mainhead'> <td colspan='3'>";
    html += tableData;
    html += "</td></tr></table>";
    let name = 'ExportTRFAAlerts';
    var ctx = { worksheet: name || 'Worksheet', table: html }
    FileSaver.saveAs((uri + base64(format(template, ctx))), "ExportTRFAAlerts.xls");
  }

}